import { GET_SALES_ORDERS, ADD_SALES_ORDER, REFUND_SALES_ORDER, SHALLOW_DELETE_SALES_ORDER } from 'redux/actionTypes';

function findSalesOrderIndex(state, salesOrderId) {
    return state.findIndex(salesOrder => salesOrder.id === salesOrderId);
};

export default function salesOrders(state = [], action) {
    switch(action.type) {
        case GET_SALES_ORDERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_SALES_ORDER:
            return [
                action.payload,
                ...state
            ];
        case REFUND_SALES_ORDER:
            const refundIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, refundIndex),
                action.payload,
                ...state.slice(refundIndex + 1)
            ];
        case SHALLOW_DELETE_SALES_ORDER:
            const deleteIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, deleteIndex),
                ...state.slice(deleteIndex + 1)
            ];
        default:
            return state;
    }
};